import * as Sentry from '@sentry/react'
import { RxDocumentBase } from 'rxdb'
import { FEATURE_TO_COINS } from 'shared/feature-to-coins'
import { REACH_LIMIT_MESSAGE } from 'shared/reach-limit'
import { z } from 'zod/mini'

import { LS_JWT_KEY } from '~/const/api'
import { Card } from '~/db/types'
import { useAccountStore } from '~/stores/account'

const safeCryptoRandomUUID = () => {
  try {
    // on IOS crypto.randomUUID() is only available in secure contexts
    return crypto.randomUUID()
  } catch {
    return Math.random().toString()
  }
}

export const streamExample = (
  upsertResult: RxDocumentBase<Card>,
  learnText: string,
  sourceText: string,
  languageQuery: string,
  onEnd?: () => void,
) =>
  new Promise((resolve, reject) => {
    const correlationId = safeCryptoRandomUUID()
    const eventSource = new EventSource(
      new URL(
        `example/sse?text=${learnText}&translation=${sourceText}${languageQuery}&correlationId=${correlationId}&token=${localStorage.getItem(LS_JWT_KEY)}`,
        import.meta.env.VITE_API_BASE,
      ),
    )
    let example = ''
    let correlationIdWasSet = false
    eventSource.onmessage = ({ data }) => {
      try {
        if (!correlationIdWasSet) {
          const { correlationId } = z.object({ correlationId: z.string() }).parse(JSON.parse(data))
          correlationIdWasSet = true

          return Sentry.setTag('correlation.id', correlationId)
        }
      } catch {}

      example = `${example}${data}`
      void upsertResult?.incrementalPatch({ examples: example })
    }
    eventSource.onerror = event => {
      eventSource.close()
      onEnd?.()
      resolve(example)
      const isCoinsLimitReached = (event as MessageEvent)?.data === REACH_LIMIT_MESSAGE
      if (isCoinsLimitReached) reject()

      useAccountStore.getState().decreaseCoins(FEATURE_TO_COINS.example)
    }
  })
